<template>
  <div class="core-container">
    <div class="coupon_main">
      <div class="coupon_main_title">
        <h2>Rabbitzhop Coupon 著數</h2>
        <div class="titleUnderline"></div>
      </div>
      <div class="couponBox row">
        <div class="big_couponEventBox col-12 col-sm-4">
          <div class="big_couponEventContent" @click="goCouponDetail(couponsFirstList.couponId)">
            <a >
              <div class="big_couponEventContent_img">
                <img :src="couponsFirstList.detailBannerUrl" alt="">
              </div>
              <div class="big_eventcontentBottom">
                <div class="row">
                  <div class="promotion-info col-12 col-sm-6 col-md-7">
                    <span class="big_percentage">{{ parseInt(couponsFirstList.amount) }}</span>
                    <ul>
                      <li class="big_per_symbol">{{ couponsFirstList.symbol }}</li>
                      <li class="big_per_text">Purchasing offer</li>
                      <li class="big_validityDate">Validity Period: <br/> {{ couponsFirstList.effectiveStartDate }} - {{ couponsFirstList.effectiveEndDate }}</li>
                    </ul>
                  </div>
                  <div class="big_content_right col-12 col-sm-6 col-md-5">
                    <div class="small_content_right_img">
                      <span> {{ couponsFirstList.merchantName }}</span>
                    </div>
                    <div class="small_redeem_button"><i class="icon"><img src="@/assets/images/icon-heart.svg"></i>兌換</div>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <div class="small_couponEventBox style2 col-12 col-sm-8">
          <div class="row">
            <div class="small_couponEventBigContent col-12 col-sm-6" v-for="list in couponsList" :key="list.id" @click="goCouponDetail(list.couponId)">
              <div class="small_couponEventContent theme2">
                <div class="panel-body">
                  <div class="row">
                    <div class="small_couponEventContent_img col-4 col-sm-5" ref="imgBox" :style="{}" >
                      <div class="img-wrapper"><img :src="list.detailBannerUrl" alt=""></div>
                    </div>
                    <div class="small_content_right col-8 col-sm-7">
                      <div class="small_content_right_img">
                        <span>{{ list.merchantName }}</span>
                      </div>
                      <ul>
                        <li class="small_per_symbol"><span class="small_percentage">{{ parseInt(list.amount) }}</span>{{ list.symbol }}</li>
                        <li class="small_per_text">Purchasing offer</li>
                        <li class="small_validityDate">Validity Period: {{ couponsFirstList.effectiveStartDate }} - {{ couponsFirstList.effectiveEndDate }}</li>
                      </ul>
                      <div class="verbar"><div class="small_redeem_button"><i class="icon"><img src="@/assets/images/icon-heart.svg"></i>兌換</div></div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="more" @click="goCouponPage">
        {{ $t("mainContent.more") }}
      </div>
    </div>
  </div>
</template>
<script>
import { getCoupons } from '@/api/coupon'

export default {
  name: 'CanvasRebbin',
  data () {
    return {
        fullWidth: document.documentElement.clientWidth,
      indent_style: '',
      validity_period: '05/01/2020 ~ 12/12/2020',
      couponsList: [],
      couponsFirstList: [],
      eventImgHeight: ''
    }
  },
  mounted () {
      getCoupons({ pageSize: 5 }).then(res => {
          this.couponsList = res.list

        if (this.fullWidth > 1000) {
            this.couponsFirstList = this.couponsList[0]
            this.couponsList.shift()
        }
        console.log(this.couponsFirstList)
        console.log(this.couponsList)
      })

        const that = this
        window.onresize = () => {
            return (() => {
                const imgBox = this.$refs.imgBox
                const wImgbox = imgBox[0].getBoundingClientRect().width
                that.eventImgHeight = wImgbox + 'px'
            })()
        }
  },
  watch: {
      /* 监听 */
      fullWidth (val) {
        if (!this.timer) {
          this.fullWidth = val
          this.timer = true
          const that = this
          setTimeout(function () {
            that.timer = false
            console.log('11')
          }, 400)
        }
      },
      couponsList: function () {
            if (this.couponsList != '') {
                this.$nextTick(() => {
                    this.initContentImg()
                })
            }
        }
  },
  methods: {
      initContentImg: function (params) {
            const imgBox = this.$refs.imgBox
            const wImgbox = imgBox[0].getBoundingClientRect().width
            this.eventImgHeight = wImgbox + 'px'
      },
      goCouponDetail: function (params) {
          const couid = params
          this.$router.push({ path: `/coupon/${couid}` })
      },
      goCouponPage: function (params) {
          this.$router.push({ path: '/coupon' })
      }
  }
}
</script>
<style scoped>

.titleUnderline{
    width: 50px;
    background: #FFBF00;
    border-radius: 3px;
    height: 5px;
    margin-top: 10px;
}
.titleUnderline::after{
    content: "";
    display: block;
    width: 5px;
    background: #FFBF00;
    border-radius: 3px;
    height: 5px;
    margin-top: 10px;
    margin-left: 60px;
}

.coupon_main .big_redeem_button:hover {
    background: #FF5A60!important;
    transform: scale(1.2);
}
.coupon_main .big_redeem_button {
    position: absolute;
    width: 100px;
    height: 40px;
    border: 0;
    font-size: 14px;
    color: #ffffff;
    background: #FFBF00;
    border-radius: 3px;
    bottom: 10px;
    right: 0px;
    text-align: center;
    line-height: 40px;
    transition-duration: .5s;
}

@media (max-width: 1600px) and (min-width: 1350px){

    .big_percentage{
        font-size: 60px;
    }
}
@media (max-width: 1350px) and (min-width: 976px){

    .big_couponEventBox {
        width: 31%;
    }
    .big_percentage{
        font-size: 50px;
    }
    .small_per_symbol{
        font-size: 20px;
    }

}

</style>
